export default __webpack_public_path__ + "static/media/lock.79301983.svg";